import { Dialog, DialogContent, DialogTitle, IconButton, Box, Typography } from "@mui/material";
import PrendaForm from "./PrendaForm";
import { Cancel } from "@mui/icons-material";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import { useSelector } from "react-redux";

const PrendaModal = ({ mode, open, handleClose }) => {
    const { defaultData } = useSelector(({ prenda }) => prenda);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen
            PaperProps={{
                sx: {
                    background: "#fafafa",
                    ".dark &": { background: "#0f172a" },
                }
            }}
        >
            {/* Header */}
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{
                    background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
                    px: 3, py: 2,
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <ContentCutIcon sx={{ color: "#fff", fontSize: 24 }} />
                        <Box>
                            <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#fff", fontSize: "1.1rem" }}>
                                {mode === "POST" ? "Nueva Prenda" : "Editar Prenda"}
                            </Typography>
                            {mode === "PUT" && defaultData?.nombre && (
                                <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.75rem", color: "rgba(255,255,255,0.8)" }}>
                                    {defaultData.nombre}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <IconButton onClick={handleClose} sx={{ color: "#fff", "&:hover": { background: "rgba(255,255,255,0.15)" } }}>
                        <Cancel />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                <PrendaForm defaultData={defaultData} handleClose={handleClose} mode={mode} />
            </DialogContent>
        </Dialog>
    );
};
export default PrendaModal;